import React, { useState, useEffect } from 'react';

export default function Login({ onLogin }) {
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('verified') === '1') {
      setMessage('Email verified. You can now log in.');
      window.history.replaceState({}, '', '/');
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); setError(''); setMessage('');
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (res.ok) { onLogin(); }
      else { setError(data.error || 'Login failed.'); }
    } catch { setError('Connection error. Try again.'); }
    finally { setLoading(false); }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true); setError(''); setMessage('');
    try {
      const res = await fetch('/api/auth/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage(data.message);
        setEmail(''); setPassword('');
        setMode('login');
      } else { setError(data.error || 'Signup failed.'); }
    } catch { setError('Connection error. Try again.'); }
    finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <h1>Gleaner</h1>
        <p className="tagline">Your story scraps, all in one place.</p>

        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem', background: '#f0f0f0', borderRadius: '6px', padding: '3px' }}>
          <button
            onClick={() => { setMode('login'); setError(''); setMessage(''); }}
            style={{ flex: 1, padding: '0.4rem', border: 'none', borderRadius: '4px', cursor: 'pointer', fontFamily: 'sans-serif', fontSize: '0.875rem', background: mode === 'login' ? '#fff' : 'transparent', fontWeight: mode === 'login' ? 500 : 400 }}
          >Log in</button>
          <button
            onClick={() => { setMode('signup'); setError(''); setMessage(''); }}
            style={{ flex: 1, padding: '0.4rem', border: 'none', borderRadius: '4px', cursor: 'pointer', fontFamily: 'sans-serif', fontSize: '0.875rem', background: mode === 'signup' ? '#fff' : 'transparent', fontWeight: mode === 'signup' ? 500 : 400 }}
          >Create account</button>
        </div>

        {message && <p style={{ color: 'var(--yes)', fontFamily: 'sans-serif', fontSize: '0.875rem', marginBottom: '1rem', background: '#edf7f2', padding: '0.75rem', borderRadius: '6px' }}>{message}</p>}
        {error && <p className="login-error">{error}</p>}

        <form onSubmit={mode === 'login' ? handleLogin : handleSignup}>
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoFocus
          />
          <input
            type="password"
            placeholder={mode === 'signup' ? 'Password (min. 8 characters)' : 'Password'}
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? '...' : mode === 'login' ? 'Log in' : 'Create account'}
          </button>
        </form>

        {mode === 'signup' && (
          <p style={{ fontFamily: 'sans-serif', fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: '1rem', lineHeight: 1.5 }}>
            You'll receive a verification email before you can log in.
          </p>
        )}
      </div>
    </div>
  );
}
